import React from 'react';
import {withRouter} from 'react-router';
import authenticationService from '../../../authenticationService';
import CustomerPortalAction from '../../../actions/CustomerPortalAction';
import CustomerPortalStore  from '../../../stores/CustomerPortalStore';

import Header from './Header';
import Footer from './Footer';

import Loading from '../Common/Loading';

class HeaderAndFooter extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      headerInfo:{},
      features:[],
      salesperson:'',
      language:'',
      isLoggedIn: false,
      isLoading:true,
      userType:'',
    };
    this._onChange = this._onChange.bind(this);
    CustomerPortalStore.addChangeListener(this._onChange);
  }
  _onChange(){
    var header = CustomerPortalStore.getHeaderInfo();
    var userType = CustomerPortalStore.getCurrentUserType();
      if (header) {
        //if (header.newLogin && !this.state.isLoggedIn) this.props.history.replace('/');
        if(header.header.headerInfo.companyName) document.getElementById('companyName').value = header.header.headerInfo.companyName;
        this.setState({
          headerInfo:header.header.headerInfo,
          isLoggedIn:header.header.login,
          features: header.header.features,
          salesperson: header.salesperson,
          userType: userType,
          language: header.language,
          isLoading:false
        });
    }
  }
  componentDidMount(){
    //this will basicall be the first thing after the base component is loaded
    //put login validation here, kick user to login page using history
      let authorization = authenticationService();
      let isLoggedIn = !(typeof authorization === "object");
      let client = (localStorage.client)? (JSON.parse(localStorage.client)) : (undefined) ;
      if(client) CustomerPortalAction.setClientNumber(client).then(function(result){
        if(result){
            this.props.history.push('/salesperson');
            localStorage.removeItem('client');
        }
      }.bind(this));;
      CustomerPortalAction.fetchHeaderInfo(isLoggedIn);
  }
  componentWillUnmount() {
    CustomerPortalStore.removeChangeListener(this._onChange);
  }
  logout(){
    localStorage.removeItem('currentUser');
    localStorage.removeItem('openpages');
    sessionStorage.removeItem('currentUser');
    localStorage.removeItem('client');
    CustomerPortalAction.logout().then(() => {
        this.props.history.push('/login');
    });
  }
  switchLanguage(language) {
      this.setState({language:language})
      CustomerPortalAction.switchLanguage(language);
  }
  render() {
    let customization = JSON.parse(localStorage.customization || "{}").customizations;
    if(this.state.isLoading) return(<Loading noSpace/>)
    return (
      <div>
        <Header
            logoURL={this.state.headerInfo.logo}
            companyName={this.state.headerInfo.companyName}
            features = {this.state.features}
            customization = {customization}
            language={this.state.language}
            hideMenu={this.props.location.pathname === '/' || this.props.location.pathname === '/quickpay' || this.props.location.pathname === '/salesperson'}
            displayLogin={this.props.location.pathname !== '/login'}
            userName = {this.state.headerInfo.userName}
            userType = {this.state.userType}
            logout = {this.logout.bind(this)}
            isLoggedIn = {this.state.isLoggedIn}
            salesperson = {this.state.salesperson}
            switchLanguage = {this.switchLanguage.bind(this)}
        />
        <main>
          {this.props.children}
        </main>
        <Footer
          address = {this.state.headerInfo.address}
          phone = {this.state.headerInfo.phone}
          url = {this.state.headerInfo.url}
        />
      </div>
    );
  }
}

export default withRouter(HeaderAndFooter);
